import React, { Component } from 'react'
import DigitalSidebar from './DigitalSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import Loading from '../../components/common/Loading';
import NoData from '../../components/common/NoData';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../../Config/FbConfig';

export default class EResources extends Component {

    state = { Datas: [] }

    //Load Data Here
    async componentDidMount() {
        const docRef = doc(firestore, "Library", "LibraryEResources");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            var Data = []
            Object.entries(docSnap.data()).forEach(([key, value]) => {
                Data.push(Object.assign({ Id: key, Priority: value.Priority != undefined ? value.Priority : "999" }, value))
            });
            Data.sort(function (a, b) { return a.Priority - b.Priority; });
            Data.length === 0 ?
                this.setState({ Datas: "NO_999" }) :
                this.setState({ Datas: Data })
        } else {
            this.setState({
                Datas: "NO_999"
            })
        }
    }

    render() {
        return (
            <div>
                {/* Header */}
                <Header />

                {/* Banner */}
                <Banner title="Digital Library" image="banner/library-3.jpg" />

                {/* Content */}
                <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-lg-9 content-area order-lg-2">
                                <div className="ttm-service-single-content-area paddingtop-2">
                                    <div className="section-title with-desc text-left clearfix">
                                        <div className="title-header" style={{ borderTopColor: "red" }}>
                                            <h4 className="title">E-Resources</h4>
                                        </div>
                                    </div>
                                    <table class="table">
                                        <thead style={{ backgroundColor: "#98002e", color: "white" }}>
                                            <tr>
                                                <th scope="col">SL No</th>
                                                <th scope="col">Name of Publishers</th>
                                                <th scope="col">Website Address</th>
                                                <th scope="col">Files/List</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.Datas.length === 0 ? <Loading /> :
                                                    this.state.Datas === "NO_999" ? <NoData /> :
                                                        this.state.Datas.map((data, i) => (
                                                            <tr>
                                                                <td>{i+1}</td>
                                                                <td>{data.PublishersName}</td>
                                                                <td><a href={data.Website} target="_blank">Click Here</a></td>
                                                                <td><a href={data.File} target="_blank">Download</a></td>
                                                            </tr>
                                                        ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-lg-3 widget-area">
                                <DigitalSidebar />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <Footer />
            </div>
        )
    }
}
